import React from "react";
import { RotateCcw, X, ChevronUp, HeartHandshake, Star } from "lucide-react";

function ActBtn({ label, testid, onClick, disabled, size, children, extra = "" }) {
  return (
    <button
      aria-label={label}
      title={label}
      data-testid={testid}
      onClick={onClick}
      disabled={disabled}
      style={{ width: size, height: size }}
      className={`flex items-center justify-center rounded-full shadow-soft transition-transform active:scale-90 disabled:cursor-not-allowed disabled:opacity-40 ${extra}`}
    >
      {children}
    </button>
  );
}

export default function ActionBar({ onUndo, onSkip, onLearn, onSupport, onSave, canUndo, saved, supportEnabled = true }) {
  return (
    <div className="flex items-center justify-center gap-3 sm:gap-4" data-testid="action-bar">
      <ActBtn label="Undo last swipe" testid="action-undo" onClick={onUndo} disabled={!canUndo} size={48} extra="bg-white/10 text-white">
        <RotateCcw size={20} />
      </ActBtn>
      <ActBtn label="Skip" testid="action-skip" onClick={onSkip} size={64} extra="bg-white text-coral-500">
        <X size={28} strokeWidth={3} />
      </ActBtn>
      <ActBtn label="Learn more" testid="action-learn" onClick={onLearn} size={56} extra="bg-white text-sky-500">
        <ChevronUp size={26} strokeWidth={3} />
      </ActBtn>
      {supportEnabled ? (
        <>
          <ActBtn label="Support" testid="action-support" onClick={onSupport} size={72} extra="bg-gradient-to-br from-gold-500 to-gold-400 text-navy-900 shadow-gold-glow">
            <HeartHandshake size={32} />
          </ActBtn>
          <ActBtn label={saved ? "Saved" : "Save for later"} testid="action-save" onClick={onSave} size={48} extra="bg-white/10">
            <Star size={20} className={saved ? "fill-candy-500 text-candy-500" : "text-candy-500"} />
          </ActBtn>
        </>
      ) : (
        <ActBtn label="Save to favourites" testid="action-support" onClick={onSupport} size={72} extra="bg-gradient-to-br from-gold-500 to-gold-400 text-navy-900 shadow-gold-glow">
          <Star size={32} className={saved ? "fill-navy-900" : ""} />
        </ActBtn>
      )}
    </div>
  );
}
